import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dependents as SectionKey } from 'Consts/Questionnaire';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import BoolInput from '../Fields/BoolInput';
import DateInput from '../Fields/DateInput';
import FieldList from '../Fields/FieldList';
import RadioInput from '../Fields/RadioInput';
import SocialSecurityInput from '../Fields/SocialSecurityInput';
import TextInput from '../Fields/TextInput';
import TextareaInput from '../Fields/TextareaInput';
import SelectInput from '../Fields/SelectInput';
import Section from '../Section';

function DependentList({ id, children: removeButton, expanded }) {
  const [types, setTypes] = useState([]);
  const [dependentFirstName, setDependentFirstName] = useState('');
  const [dependentLastName, setDependentLastName] = useState('');
  const { householdResource } = useSimpleHousehold();

  async function getTypes(hhResource) {
    const clientCollection = await hhResource.relationship(fr.relationships.clients.name).getRelated();
    const meta = clientCollection.meta();
    const gradeOptions = meta.field('grade').options().list().map(option => ({
      id: option.id(),
      value: option.attr('prompt'),
    }));
    gradeOptions.unshift({ id: '', value: '- Please select -' });
    setTypes(gradeOptions);
  }

  useEffect(() => {
    if (householdResource) {
      getTypes(householdResource);
    }
  }, [householdResource]);


  function getChildName() {
    const name = `${dependentFirstName || ''} ${dependentLastName || ''}`.trim();
    return name || 'New Dependent';
  }


  return (
    <LabeledVerticalExpander
      transitionSpeed={0.15}
      title={getChildName()}
      removeButton={removeButton}
      expanded={expanded}
      firstElementFocusable
    >
      <TextInput
        placeholder="First name"
        name={`dependentFirstName.${id}`}
        answerKey="dependentFirstName"
        onChange={(name, value) => setDependentFirstName(value)}
      />
      <TextInput
        placeholder="Last name"
        name={`dependentLastName.${id}`}
        answerKey="dependentLastName"
        onChange={(name, value) => setDependentLastName(value)}
      />
      <DateInput
        placeholder="Date of birth"
        name={`dependentDOB.${id}`}
        answerKey="dependentDateOfBirth"
        displayInLocalTime={false}
      />
      <SocialSecurityInput
        placeholder="Social security number"
        name={`dependentSSN.${id}`}
        answerKey="dependentSocialSecurityNumber"
      />
      <BoolInput
        label="Is this dependent in school?"
        name={`dependentInSchool.${id}`}
        answerKey="dependentInSchool"
        checkedChildren={
          <Fragment>
            <RadioInput
              placeholder="What type of school?"
              name={`dependentSchoolType.${id}`}
              answerKey="dependentSchoolType"
              options={[
                {
                  id: 'public',
                  text: 'Public',
                },
                {
                  id: 'private',
                  text: 'Private',
                },
              ]}
            />
            <SelectInput
              label="Grade"
              name={`dependentGrade.${id}`}
              answerKey="dependentGrade"
              // onChange={(name, value) => onChange('dependentGrade', value)}
              // onMount={(name, value) => onChange('dependentGrade', value)}
              options={types}
            />
          </Fragment>
          }
      />
      <BoolInput
        label="Anticipated education changes?"
        name={`dependentIsAnticipatedChange.${id}`}
        answerKey="dependentIsAnticipatedChange"
        checkedChildren={
          <TextareaInput
            placeholder="Anticipated education changes"
            name={`dependentAnticipatedChange.${id}`}
            answerKey="dependentAnticipatedChange"
          />
          }
      />
    </LabeledVerticalExpander>
  );
}

DependentList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

DependentList.defaultProps = {
  expanded: false,
};

const Dependents = ({ isLastSection }) => (
  <Section
    transitionSpeed={0.25}
    height={400}
    title="Dependents"
    isLastSection={isLastSection}
    sectionKey={SectionKey}
  >
    <FieldList
      addLabel="Add a dependent"
      label="Dependents"
      keyPrefix="dependents"
      Of={DependentList}
    />
  </Section>
);

Dependents.propTypes = {
  isLastSection: PropTypes.bool,
};

Dependents.defaultProps = {
  isLastSection: false,
};

export default Dependents;
